import { IOpChangeState, IOpData, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from './op-data-type'
import { OpUnit } from './op-unit'
import { Utils } from '../util/utils'

export class OpData implements IOpData, IOpChangeState, ICopyable<OpData> {

    // #region Properties

    public idData: number
    public serialNbr: number
    public idMeter: number
    public idLocation: number
    public idDataType: number
    public indexNbr: number
    public value: any
    public status: Enums.DataStatus

    // #endregion

    // #region NavigationProperties

    public dataType: OpDataType

    // #endregion

    constructor(opObj: any) {
        if (opObj instanceof OpData) {
            this.copy(opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #region Custom Properties

    public get unit(): OpUnit { return this.dataType != null ? this.dataType.unit : null }

    // #endregion

    // #region IOpData implementation

    //public get idData() { return this.idData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(value: number) { this.indexNbr = value }
    //get value() { return this.value }

    // #endregion

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion IOpChangeState implementation end

    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idData = opObj.ID_DATA
            this.serialNbr = opObj.SERIAL_NBR
            this.idMeter = opObj.ID_METER
            this.idLocation = opObj.ID_LOCATION
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.status = opObj.STATUS
            this.opState = opObj.OpState

        } else {
            this.idData = 0
            this.opState = Enums.OpChangeState.New
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DATA: this.idData,
            SERIAL_NBR: this.serialNbr,
            ID_METER: this.idMeter,
            ID_LOCATION: this.idLocation,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            STATUS: this.status
        }
    }

    //#endregion 



    //#region toString

    public toString() {
        return "Data [" + this.idData + "]"
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpData {
        const newData: OpData = new OpData(null)

        newData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newData
    }

    public copy(source: OpData, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        Utils.copyIOpData(this, source, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        this.idData = source.idData
        this.idLocation = source.idLocation
        this.idMeter = source.idMeter
        this.serialNbr = source.serialNbr
    }

    //#endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpData {
        const newData: OpData = new OpData(null)

        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}